{
  "CommonAdminAllTelServer": "[Tous les serveurs de téléphonie]",
  "CommonAdminAnyPartition": "[N'importe quelle partition]",
  "CommonAdminAnyDevices": "[Tous les appareils]",
  "CommonAdminAnyAgents": "[Tout agent ACD]",
  "CommonAdminAnyAgentForDevice": "[Any At Set Device]",
  "CommonAdminAnyDeviceForAgent": "[Any With Set ACD Agent]",
  "CommonAdminUnknownOrDeleted": "[Inconnu ou supprimé]",
  "NAME": "CommonAdmin"
}